import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
/**
 * This class stores up and down queries needed for migrations functionality.
 */
export var SqlInMemory = /*#__PURE__*/_createClass(function SqlInMemory() {
  _classCallCheck(this, SqlInMemory);
  this.upQueries = [];
  this.downQueries = [];
});